import React from "react";
import type { GlossaryId } from "~/generated/glossary.types";
import GlossaryInfoIcon from "~/widgets/GlossaryInfoIcon/GlossaryInfoIcon";
import styles from "~/pages/CharacterSheet/widgets/CoreStatControl/CoreStatControl.module.scss";

export interface CoreStatControlProps {
    label: string;
    value: number;
    glossaryId: GlossaryId;
    id: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

function CoreStatControl({
  label,
  value,
  glossaryId,
  id,
  onChange,
}: CoreStatControlProps): React.ReactElement {
  return (
    <div className={styles.statControl}>
      <label htmlFor={id}>
        {label}
        <GlossaryInfoIcon glossaryId={glossaryId} className={styles.infoIcon} />
      </label>
      <input id={id} type="number" value={value} onChange={onChange} />
    </div>
  );
}

export default CoreStatControl;
